module.exports = __webpack_public_path__ + "img/appDownload.e613d5f7.png";